import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import * as API from '@/api';


function initialState () {
  return {
    list: [],
  };
}

const state = initialState ();

// actions

const actions = {
  async list (context, payload) {
    var response = await API.wishlist.list ();
    context.commit ('set_list', {
      response: response.result,
    });
    return response;
  },

  async add (context, payload) {
    var response = await API.wishlist.add (payload);
    context.commit ('set_list', {
      response: response.result,
    });
    context.dispatch (
      'app/showMessage',
      {
        message: 'Added successfully',
        color: 'green',
      },
      DEFINES.USE_ROOT
    );
    return response;
  },

  async remove (context, payload) {
    var response = await API.wishlist.remove (payload);
    context.commit ('set_list', {
      response: response.result,
    });
    context.dispatch (
      'app/showMessage',
      {
        message: 'Removed successfully',
        color: 'green',
      },
      DEFINES.USE_ROOT
    );
    return response;
  },

  async submit (context) {
    var response = await API.wishlist.submit ();
    context.commit ('set_list', {
      response: response.result,
    });
  },
};

// getters
const getters = {
  getField,
  getList: state => {
    return state.list;
  },
};

// mutations
const mutations = {
  updateField,
  set_list (state, payload) {
    state.list = payload.response;
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
